export default __webpack_public_path__ + "static/media/gallery12.3c74b60f.jpg";